import React, { useState, ReactNode } from "react";
import PopupSidebar from "./PopupSidebar";

const Layout = ({ children }: { children: ReactNode }) => {
  // State για το αν το sidebar είναι ανοιχτό
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="flex min-h-screen w-full bg-secondary overflow-x-hidden">
      {/* Sidebar */}
      <PopupSidebar onHoverChange={(status) => setIsSidebarOpen(status)} />

      {/* Main Content Area: 
          Προσθήκη min-w-0 για να σταματήσει το overflow της σελίδας 
      */}
      <main
        className={`flex-1 min-w-0 w-full transition-all duration-300 ease-in-out ${
          isSidebarOpen ? "pl-64" : "pl-20"
        }`}
      >
        <div className="p-8 w-full min-w-0">{children}</div>
      </main>
    </div>
  );
};

export default Layout;